// extracted by mini-css-extract-plugin
module.exports = {"section-left-info":"SectionLeftInfo_section-left-info__eK7iu"};